import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../lib/api'
import type {
  LatenessReportResponse,
  LatenessReportFilters,
  NoScheduleReportResponse,
  NoScheduleReportFilters,
  TimesheetReportResponse,
  TimesheetReportFilters,
} from '../types/reports.types'

const REPORTS_QUERY_KEY = 'reports'

export const useLatenessReport = (filters: LatenessReportFilters, enabled: boolean = true) => {
  return useQuery({
    queryKey: [REPORTS_QUERY_KEY, 'lateness', filters],
    queryFn: async (): Promise<LatenessReportResponse> => {
      const response = await apiClient.getLatenessReport(filters)
      return response
    },
    enabled: enabled && !!filters.date,
    staleTime: 60 * 1000, // 1 minute
    retry: 2,
  })
}

export const useNoScheduleReport = (filters: NoScheduleReportFilters, enabled: boolean = true) => {
  return useQuery({
    queryKey: [REPORTS_QUERY_KEY, 'no-schedule', filters],
    queryFn: async (): Promise<NoScheduleReportResponse> => {
      const response = await apiClient.getNoScheduleReport(filters)
      return response
    },
    enabled,
    staleTime: 60 * 1000, // 1 minute
    retry: 2,
  })
}

export const useTimesheetReport = (filters: TimesheetReportFilters, enabled: boolean = true) => {
  return useQuery({
    queryKey: [REPORTS_QUERY_KEY, 'timesheet', filters],
    queryFn: async (): Promise<TimesheetReportResponse> => {
      const response = await apiClient.getTimesheetReport(filters)
      return response
    },
    enabled: enabled && !!filters.year && !!filters.month,
    staleTime: 60 * 1000, // 1 minute
    retry: 2,
  })
}
